<template>
    <div>
        <div class="large-8 columns content__column">
            <template v-if="config.localeApp == 'se'">
                <h2>BURES BOAHTIN DIEĐÁHUSBÁLVALUSSII</h2>
                <p><em>Bálvalus lea anonyma, ja don it dárbbaš almmuhit iežat persovnnalaš dieđuid.</em></p>
                <p><strong>Leage buorre ja čálit iežat sisa.</strong></p>
            </template>
            <template v-else-if="!testSite">
                <h2>Velkommen til meldingstjenesten!</h2>
                <p><em>Tjenesten er anonym, og du behøver ikke oppgi personlige opplysninger.</em></p>
                <p><strong>Vennligst logg deg inn.</strong></p>
            </template>
            <template v-else>
                <h2>Testside for meldingstjenesten</h2>
                <p><strong>Vennligst logg deg inn for å skrive en melding.</strong></p>
            </template>

            <div v-if="unauthorized" class="form__errors">
                <template v-if="config.localeApp == 'se'">
                    Boastu geavaheaddjinamma dahje beassansátni
                </template>
                <template v-else>
                    Feil brukernavn eller passord
                </template>
            </div>

            <div class="row form">
                <div class="form__field small-12 medium-7 columns">
                    <label class="form__label">
                        <template v-if="config.localeApp == 'se'">
                            Geavaheaddjinamma
                        </template>
                        <template v-else>
                            Brukernavn
                        </template>
                        <span class="form__required">*</span>
                        <input
                            type="text"
                            name="username"
                            maxlength="255"
                            required
                            autofocus
                            v-model="username"
                            v-on:keyup.enter="login"
                            v-validate="'required'"
                            data-vv-as="Brukernavn"
                        />
                        <span v-show="errors.has('username')" class="form__field__error">{{ errors.first('username') }}</span>
                    </label>
                </div>
                <div class="form__field small-12 medium-7 columns">
                    <label class="form__label">
                        <template v-if="config.localeApp == 'se'">
                            Beassansátni
                        </template>
                        <template v-else>
                            Passord
                        </template>
                        <span class="form__required">*</span>
                        <input
                            type="password"
                            name="password"
                            maxlength="255"
                            required
                            v-model="password"
                            v-on:keyup.enter="login"
                            v-validate="'required'"
                            data-vv-as="Passord"
                        />
                        <span v-show="errors.has('password')" class="form__field__error">{{ errors.first('password') }}</span>
                    </label>
                </div>
                <div class="form__field small-12 medium-7 columns" v-if="config.localeApp != 'se'">
                    <label>
                        <input type="checkbox" v-model="acceptedTerms" /> Jeg har lest og akseptert
                        <router-link :to="{ name: 'Terms' }">brukeravtalen</router-link>.
                    </label>
                    <br>
                    <span v-if="!acceptedTerms && showAcceptedTerms" class="form__field__error">Du må krysse av for at du har lest og akseptert brukeravtalen.</span>
                </div>

                <p class="small-12 large-7 columns">
                    <router-link :to="{ name: 'RecoverPassword' }">
                        <template v-if="config.localeApp == 'se'">
                            Veahket! Mun lea vajáldahttán iežan beassansáni.
                        </template>
                        <template v-else>
                            Hjelp! Jeg har glemt passordet mitt.
                        </template>
                    </router-link>
                </p>
                <div class="form__submit small-12 large-7 columns">
                    <button @click.prevent="login" class="button form__submit__button">
                        <template v-if="config.localeApp == 'se'">
                            Sisačálit iežat
                        </template>
                        <template v-else>
                            Logg inn
                        </template>
                    </button>
                </div>
            </div>
            <template v-if="config.localeApp == 'se'">
                <p>
                    Háliidat go geavahit SOS-dieđáhusaid, de fertet čálihit iežat geavaheaddjin.<br />
                    Dalle oaččut iežat “boastakássa” Girku SOS neahttasiidduin.<br />
                    Jus áiggut lohkat Girku SOS vástádusaid, de fertet čálihuvvot sisa dán siiddus.<br />
                </p>
                <ul>
                    <li><router-link :to="{ name: 'Register' }">Dás sáhtát čálihuvvot ođđa geavaheaddjin</router-link>.</li>
                    <li><a href="https://girku-sos.no/nordsamisk/sos-diedahus/birra">Dás gávnnat dieđuid SOS-dieđáhusaid birra</a>.</li>
                </ul>
            </template>
            <template v-else>
                <p>
                    Hvis du vil bruke SOS-meldingene, må du registrere deg som bruker.<br />
                    Da får du din egen "postkasse" på nettsidene til Kirkens SOS.<br />
                    For å lese svarene fra Kirkens SOS, logger du deg så inn på denne siden.
                </p>
                <ul>
                    <li><router-link :to="{ name: 'Register' }">Her kan du registrere deg som ny bruker.</router-link></li>
                    <li><a href="https://www.kirkens-sos.no/melding/om-sos-melding">Her finner du informasjon om SOS-meldinger</a>.</li>
                </ul>
            </template>
        </div>
        <div class="large-4 columns content__aside content__aside--aligned" v-if="config.localeApp == 'se'">
            <h3>SOS-DIEĐÁHUSAID BIRRA</h3>
            <p class="txt"><a href="https://girku-sos.no/nordsamisk/sos-diedahus/birra">Háliidat go diehtit eanet SOS-dieđáhusaid birra.</a></p>

            <h3>EAIGO SOS-DIEĐÁHUSAT DOAIMMA DU MAŠIINNAS?</h3>
            <p class="txt">
                Jus dus leat váttisvuođat iežat čálihit sisa SOS-dieđáhusbálvalussii, de sáhttá sivvan leat ahte iežat mašiinna dorvoheivehusat bearehaga
                gáržžidit lohkanvejolašvuođaid.
                <a href="https://girku-sos.no/nordsamisk/heahtebalvalussii/iigo-sms-diedahus-doaimma"
                    >Oza cavgilemiid dasa movt oažžut SOS-dieđáhusaid doaibmat du mašiinnas.</a
                >.
            </p>

            <h3>MÁHCAHAGAT HEAHTEBÁLVALUSSII</h3>
            <p class="txt">
                Mii leat olbmot geat bargat Girku SOS bálvalusas, ja olmmoš sáhttá meaddit. Mii sávvat ahte don ovddidat dieđuid jus it leat duhtavaš dainna
                movt mii vuostáiválddiimet du go váldet oktavuođa Girku SOS bálvalusain.
                <a href="https://www.kirkens-sos.no/krisetjenesten/tilbakemeldinger-p%C3%A5-sos-tjenestene">Sáddes áinnas jus cuiggodat min bálvalusaid.</a>
            </p>
        </div>
        <div class="large-4 columns content__aside content__aside--aligned" v-else-if="!testSite">
            <h3>Om SOS-meldinger</h3>
            <p class="txt"><a href="https://www.kirkens-sos.no/melding/om-sos-melding">Vil du vite mer om SOS-meldingene.</a></p>

            <h3>Tilbakemelding på krisetjenesten</h3>
            <p class="txt">
                Vi er mennesker på Kirkens SOS og mennesker kan gjøre feil. Vi ønsker at du gir oss beskjed dersom du ikke er fornøyd med måten du ble møtt på
                når du kontaktet Kirkens SOS.
                <a href="https://www.kirkens-sos.no/krisetjenesten/tilbakemeldinger-p%C3%A5-sos-tjenestene">Gi oss tilbakemelding på tjenestene våre.</a>
            </p>
        </div>
    </div>
    </div>
</template>

<script>
import { config } from '../../volunteer/config/config';

export default {
    data() {
        return {
            username: '',
            password: '',
            acceptedTerms: false,
            showAcceptedTerms: null,


            unauthorized: false,

            config: config,
        };
    },
    created() {
        if(this.config.localeApp == 'se') {
            this.acceptedTerms = true;
        }
        this.$auth.ready(function() {});
    },
    computed: {
        testSite() {
            return process.env.TEST || false;
        },
    },
    methods: {
        login: async function() {
            const isValid = await this.$validator.validateAll();
            if (isValid) {
                if(!this.acceptedTerms) {
                    this.showAcceptedTerms = true;
                } else {
                    try {
                        await this.$auth.login({
                            data: {
                                username: this.username,
                                password: this.password,
                            },
                            rememberMe: true,
                            redirect: '/',
                            fetchUser: true,
                        });
                    } catch (e) {
                        this.unauthorized = true;
                        //console.log(e);
                    }
                }
            }
        },
    },
};
</script>



// WEBPACK FOOTER //
// src/components/Login.vue